import { formatLicensePlateForDisplay } from "@/lib/licensePlate";
import { emptyCompanion, type CompanionFormData, type CompanionRole } from "@/lib/companionFields";

export type KnownCompanion = {
  id: string;
  role: CompanionRole;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
  license_plate: string | null;
  street: string | null;
  postal_code: string | null;
  city: string | null;
  date_of_birth: string | null;
};

export type KnownCompanionsResponse = {
  companions: KnownCompanion[];
};

export function knownCompanionLabel(c: KnownCompanion): string {
  const name = [c.first_name, c.last_name].filter(Boolean).join(" ").trim();
  return name || "Unbekannt";
}

export function companionFromKnown(
  known: KnownCompanion,
  slotRole: CompanionRole,
): CompanionFormData {
  return {
    ...emptyCompanion(slotRole),
    first_name: known.first_name ?? "",
    last_name: known.last_name ?? "",
    email: known.email ?? "",
    phone: known.phone ?? "",
    license_plate: formatLicensePlateForDisplay(known.license_plate ?? ""),
    street: known.street ?? "",
    postal_code: known.postal_code ?? "",
    city: known.city ?? "",
    date_of_birth: known.date_of_birth ?? "",
  };
}
